import React from 'react';
import { Box } from 'components';

/* hidden separator to achieve gap between 2 charts in both desktop and mobile views */
const ChartSeparator = () => (
  <Box width={30} height={30} backgroundColor="transparent" border="none" />
);

export default ChartSeparator;
